export default __webpack_public_path__ + "static/media/take-notes.940d20a9.png";